/* Countdown Timer — counts to noon Chicago (same-day shipping) or midnight Chicago (next-day shipping) */
(function () {
  'use strict';

  var el = document.querySelector('[data-countdown]');
  if (!el) return;

  var display = el.querySelector('[data-countdown-display]');
  if (!display) return;

  function chicagoOffsetHours(d) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Chicago',
        timeZoneName: 'shortOffset'
      }).formatToParts(d);
      var name = parts.find(function (p) { return p.type === 'timeZoneName'; });
      var match = name && name.value && name.value.match(/([+-]\d+)/);
      return match ? parseInt(match[1], 10) : -6;
    } catch (e) {
      return -6;
    }
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function format(remaining) {
    var totalSec = Math.max(0, Math.floor(remaining / 1000));
    var h = Math.floor(totalSec / 3600);
    var m = Math.floor((totalSec % 3600) / 60);
    var s = totalSec % 60;
    if (h > 0) return h + ':' + pad(m) + ':' + pad(s);
    return m + ':' + pad(s);
  }

  function compute() {
    // Always count down to the next 4pm Chicago.
    var now = new Date();
    var offset = chicagoOffsetHours(now);
    var chicagoNowMs = now.getTime() + offset * 3600000;
    var chicagoNow = new Date(chicagoNowMs);
    var hour = chicagoNow.getUTCHours();
    var minute = chicagoNow.getUTCMinutes();

    var pastCutoff = hour > 16 || (hour === 16 && minute >= 0);
    var dayOffset = pastCutoff ? 1 : 0;
    var targetChicagoMs = Date.UTC(
      chicagoNow.getUTCFullYear(),
      chicagoNow.getUTCMonth(),
      chicagoNow.getUTCDate() + dayOffset,
      16, 0, 0
    );

    return { remaining: targetChicagoMs - chicagoNowMs };
  }

  function tick() {
    display.textContent = format(compute().remaining);
  }

  tick();
  setInterval(tick, 1000);
})();
